import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './lib/i18n';
import './index.css';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ConsentBanner from './components/ConsentBanner';

// Pages
import Home from './pages/Home';
import Story from './pages/Story';
import Craft from './pages/Craft';
import Materials from './pages/Materials';
import Contact from './pages/Contact';
import Legal from './pages/Legal';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-primary-50">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/story" element={<Story />} />
              <Route path="/craft" element={<Craft />} />
              <Route path="/materials" element={<Materials />} />
              {/* <Route path="/faq" element={<FAQ />} /> */}
              <Route path="/contact" element={<Contact />} />
              <Route path="/legal" element={<Legal />} />
              {/* <Route path="/wholesale" element={<Wholesale />} /> */}
            </Routes>
          </main>
          <Footer />
          <ConsentBanner />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
